import React from "react";
import styled, { css } from "styled-components";

import { IProduct } from "src/core/products/api/products.api";
import {
  Text,
  TextTruncate
} from "src/library/components/Text/Text";
import { Button } from "src/library/components/Button";

import { PartNumber } from "../../PartNumber";
import { useQuickViewProduct } from "../QuickViewProduct";

interface ProductLabelProps {
  product: IProduct;
  labelLines?: number;
  hidePackSize?: boolean;
  view?: "grid" | "compact";
}

export const ProductLabel: React.ReactFCWithChildren<ProductLabelProps> = ({
  product, labelLines, hidePackSize = false, view
}) => {
  const { setQuickViewProduct } = useQuickViewProduct();

  return (
    <>

      <ProductTextWrapper className="product-label">
        <Button
          onClick={() => setQuickViewProduct(product.id)}
          $buttonType="plain"
        >
          <TextTruncate
            truncateProps={{ lines: labelLines || 1 }}
            className="description"
          >
            {product.description}
          </TextTruncate>
        </Button>

        {!hidePackSize &&
          <PartNumber product={product} />}

        {product.shelfLife && view !== "compact" && (
          <div className="shelflife-wrapper">
            <Text
              color="secondary"
              className="shelf-life"
            >
              {`Shelf life: ${product.shelfLife} ${product.shelfLifePeriod || "days"}`}
            </Text>
          </div>
        )}
      </ProductTextWrapper>
    </>
  );
};

const ProductTextWrapper = styled.div`
  ${({ theme }) => css`
    margin-bottom: ${theme.spacing.margins.md};

    .shelflife-wrapper {
      margin-top: ${theme.spacing.margins.sm};
    }

    .description {
      font-family: ${theme.fonts.family.heading};
    }
    
    button {
      padding: 0;
    }
  `}
`;
